import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';

import { SaveCancelButtonConfig } from '@models/form/button';
import { SaveCancelService } from '@core/services/state/save-cancel.service';

/**
 * Reusable component that can submit to a parent form.
 */
@Component({
  selector: 'app-save-cancel',
  templateUrl: './save-cancel.component.html',
  styleUrls: ['./save-cancel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveCancelComponent implements OnInit, OnDestroy {
  @Input()
  public buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig();
  @Input() public form: UntypedFormGroup = new UntypedFormGroup({});
  @Input() public shouldDisable: boolean = false;

  @Output() public emitCancel = new EventEmitter<void>();
  @Output() public emitSave = new EventEmitter<void>();

  disableState$: Observable<boolean>;

  constructor(
    private location: Location,
    private saveCancelService: SaveCancelService,
  ) {}

  ngOnInit(): void {
    this.disableState$ = this.saveCancelService.getDisabledState();
    this.saveCancelService.setDisabledState(false);
  }

  ngOnDestroy(): void {
    this.saveCancelService.setDisabledState(false);
  }

  public cancel(): void {
    this.buttonConfig.hasCustomCancel
      ? this.emitCancel.emit()
      : this.location.back();
  }

  public save(): void {
    this.emitSave.emit();
  }
}
